import { ThemeOptions } from "@material-ui/core";

import { bronteColors } from "./colors";
import { italianPlate } from "./fonts";

const borderRadius = 12;
const fontWeightBold = 600;
const formComponentHeight = "64px";

/****** theming *******/
export const bronteTheme: ThemeOptions = {
  palette: {
    action: {
      // disabled bgcolor for button component
      disabledBackground: bronteColors.bondiMintDisabled,
    },
    primary: {
      main: bronteColors.bondiMint,
    },
    secondary: {
      main: bronteColors.black,
    },
    error: {
      main: bronteColors.red,
    },
    success: {
      main: bronteColors.green,
    },
    warning: {
      main: bronteColors.yellow,
    },
    info: {
      main: bronteColors.orca,
    },
    text: {
      secondary: bronteColors.gray30,
    },
  },
  props: {
    MuiButton: {
      disableElevation: true,
    },
  },
  shape: {
    borderRadius,
  },
  typography: {
    fontWeightBold,
    fontFamily: [
      "Italian Plate No2 Expanded",
      "Roboto",
      "Helvetica",
      "Arial",
      "sans-serif",
    ].join(","),
    fontSize: 16,
  },
  overrides: {
    MuiTabs: {
      root: {
        backgroundColor: bronteColors.white,
      },
      indicator: {
        backgroundColor: bronteColors.black,
        height: 4,
      },
    },
    MuiCssBaseline: {
      "@global": {
        html: {
          height: "100%",
        },
        body: {
          backgroundColor: bronteColors.white,
          height: "100%",
        },
        "#root": {
          height: "100%",
        },
        "@font-face": [italianPlate],
      },
    },
    MuiButton: {
      root: {
        height: formComponentHeight,
      },
      label: {
        textTransform: "none",
        fontWeight: fontWeightBold,
      },
    },
    MuiFormLabel: {
      // input label for TextField component
      root: {
        "&$focused": {
          color: bronteColors.black,
        },
        marginTop: "5px",
      },
      asterisk: {
        // remove asteryx from required textFields
        display: "none",
      },
    },
    MuiLink: {
      root: {
        color: bronteColors.orca,
      },
    },
    MuiOutlinedInput: {
      // variant="outline" TextField
      root: {
        height: formComponentHeight,
      },
    },
    MuiAccordionSummary: {
      root: {
        minHeight: "2.5rem",
        "&$expanded": {
          minHeight: "2.5rem",
        },
      },
      content: {
        "&$expanded": {
          margin: "0.8rem 0rem",
        },
      },
    },
    MuiAccordion: {
      root: {
        border: "none",
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        "&$checked": {
          color: bronteColors.orca,
        },
      },
    },
  },
  bronte: {
    palette: {
      ...bronteColors,
    },
    typography: {
      fontWeightBold: fontWeightBold,
    },
  },
};
